import consts from "shared/consts";
import { createElementId, getUnixTimestampUTC } from "../util/utils";
import { Point } from "./schemas/canvas-element";
import { nounIconSchema } from "./schemas/noun-icon";

interface IconInitOptions {
  id: string;
}

export function placeNounIcon({ x, y }: Point, frameId: string | undefined | null, init: IconInitOptions) {
  try {
    const icon = nounIconSchema.parse({
      type: "noun-icon",
      x,
      y,
      scaleX: 1,
      scaleY: 1,
      id: init.id,
      provider: "nounproject",
      rotate: 0,
      frameId,
      zIndexLastChangeTime: getUnixTimestampUTC(),
    });
    return {
      id: createElementId(),
      type: consts.CANVAS_ELEMENTS.NOUN_ICON,
      icon,
    };
  } catch (error: unknown) {
    console.error("New shape failed zod.parse", `${error}`, init);
    throw error;
  }
}
